import src from "IMAGE";
export default { src, width: 1560, height: 657, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARUlEQVR42n3KuwkAIRgDYLe42+BuB7X4QfBRKM6goLh/Hx8gWFl8kISw59O4Ye9vsM3hzOtAvkLFBgoV3CaQL6sLlyGHDibOJ+fB7XchAAAAAElFTkSuQmCC", blurWidth: 8, blurHeight: 3 }
